import React from "react";
import Navbar from "./components/Navbar";
import "./App.css";
import Home from "./components/pages/Home";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Products from "./components/pages/Products";
import Search from "./components/pages/Search";
import HowItWorks from "./components/pages/HowItWorks";
import Contact from "./components/pages/Contact";
import BlogArticle from "./components/pages/BlogArticle";
import { AuthProvider } from './services/authContext';
import { FiltersProvider } from './services/filtersContext';
import Profile from './components/pages/Profile';
import ResetPassword from './components/pages/ResetPassword';


function App() {
  return (
    <AuthProvider>
      <FiltersProvider>
      <Router>
        <Route path="/reset-password" component={ResetPassword} />
        <Route>
          {({ location }) => location.pathname !== '/reset-password' && <Navbar />}
        </Route>
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/services" component={Search} />
          <Route path="/products" component={Products} />
          <Route path="/how-it-works" component={HowItWorks} />
          <Route path="/contact" component={Contact} />
          <Route path="/blog/fashion-shopping-deals-2025" component={BlogArticle} />
          <Route path="/profile" component={Profile} />
        </Switch>
      </Router>
      </FiltersProvider>
    </AuthProvider>
  );
}

export default App;
